import { UserAddress } from '../../users/types/user.type';
import { DeliveryAddress } from '../types/delivery-selection.type';

export function userAddressToDeliveryAddress(userAddress: UserAddress): DeliveryAddress {
  return {
    type: 'home',
    _id: userAddress.id,
    address: userAddress.street,
    zipCode: userAddress.zipCode,
    city: userAddress.city,
    title: userAddress.title,
    comment: userAddress.comment,
  };
}
